<template>
  <div>
    <ContentHeader />

    <!-- Loading Spinner -->
    <div v-if="loading" class="loading">
      <div class="loader"></div>
      <img src="@/assets/img/logo.jpg" alt="logo" width="496" height="99" class="loaderLogo">
    </div>

    <!-- About Banner -->
    <div class="aboutBanner" data-aos="fade-out">
      <span>text</span>
    </div>

    <div class="about-page ctInner">

      <!-- About Intro -->
      <section class="about-intro block">
        <h1 class="leadTitle" data-aos="fade-up">
          About Us <br> Elemax-Tech Engineering Company Limited
        </h1>
        <p data-aos="fade-right">
          Elemax-Tech Engineering Company Limited is a trusted and leading provider
          of <strong>elevators, escalators, and moving walkways</strong> in Myanmar.
          Established with a vision to enhance vertical transportation solutions
          across the nation, we specialize in <strong>installation, modernization,
          maintenance, and repair</strong> of all types of lift and escalator systems.
        </p>
        <p data-aos="fade-left">
          Our team of experienced engineers, skilled technicians, and dedicated
          professionals is committed to delivering reliable and efficient service
          that meets international safety and performance standards.
        </p>
      </section>

      <!-- Mission -->
      <section class="about-mission block">
        <h2 data-aos="fade-up">Our Mission</h2>
        <div class="col">
          <div class="left" data-aos="fade-right">
            <img src="@/assets/img/mission.jpg" alt="mission">
          </div>
          <div class="right" data-aos="fade-left">
            <p>
              To <strong>deliver high-quality, safe, and energy-efficient vertical transportation systems</strong>
              that improve accessibility, convenience, and comfort for our customers.
              We aim to provide exceptional service through continuous innovation,
              professionalism, and customer satisfaction.
            </p>
          </div>
        </div>
      </section>

      <!-- Vision -->
      <section class="about-vision block">
        <h2 data-aos="fade-out">Our Vision</h2>
        <div class="col flip">
          <div class="left" data-aos="fade-left">
            <img src="@/assets/img/vision.jpg" alt="vision">
          </div>
          <div class="right" data-aos="fade-right">
            <p>
              To be the <strong>most trusted and innovative elevator and escalator solution provider in Myanmar</strong>,
              recognized for excellence in product quality, safety, and customer service.
            </p>
          </div>
        </div>
      </section>

      <!-- Products -->
      <section class="about-products block">
        <h2 data-aos="fade-up">What We Provide</h2>
        <figure class="imgTitle" data-aos="fade-out">
          <img src="@/assets/img/product.jpg" alt="products">
          <figcaption>Our Products</figcaption>
        </figure>
        <div class="bgTran">
          <dl data-aos="fade-right">
            <dt>Passenger Elevators:</dt>
            <dd>Safe, stylish, and energy-efficient elevators for residential and commercial buildings.</dd>
          </dl>
          <dl data-aos="fade-left">
            <dt>Home Elevators:</dt>
            <dd>Compact and elegant solutions designed for private homes.</dd>
          </dl>
          <dl data-aos="fade-right">
            <dt>Hospital Elevators:</dt>
            <dd>Spacious and smooth systems designed for medical facilities.</dd>
          </dl>
          <dl data-aos="fade-left">
            <dt>Freight Elevators:</dt>
            <dd>Heavy-duty lifts for industrial and logistic operations.</dd>
          </dl>
          <dl data-aos="fade-right">
            <dt>Panoramic Elevators:</dt>
            <dd>Glass-walled lifts for modern buildings and hotels.</dd>
          </dl>
          <dl data-aos="fade-left">
            <dt>Car Elevators:</dt>
            <dd>Reliable vertical transport solutions for vehicles.</dd>
          </dl>
          <dl data-aos="fade-up">
            <dt>Escalators & Moving Walkways:</dt>
            <dd>Durable and efficient systems for shopping malls, airports, and transit stations.</dd>
          </dl>
        </div>
      </section>

      <!-- Services -->
      <section class="about-services block">
        <figure class="imgTitle" data-aos="fade-out">
          <img src="@/assets/img/product.jpg" alt="products">
          <figcaption>Our Services</figcaption>
        </figure>
        <div class="bgTran">
          <dl data-aos="fade-right">
            <dt>🧰 Installation:</dt>
            <dd>Professional installation of new elevators and escalators with strict adherence to safety standards.</dd>
          </dl>
          <dl data-aos="fade-left">
            <dt>🔧 Maintenance:</dt>
            <dd>Regular inspection and servicing to ensure smooth and safe operation of all systems.</dd>
          </dl>
          <dl data-aos="fade-right">
            <dt>⚙️ Modernization:</dt>
            <dd>Upgrading old elevators and escalators with the latest technology for improved performance and safety.</dd>
          </dl>
          <dl data-aos="fade-left">
            <dt>🔄 Repair:</dt>
            <dd>Fast and efficient repair solutions to minimize downtime.</dd>
          </dl>
          <dl data-aos="fade-right">
            <dt>🧩 Spare Parts Supply:</dt>
            <dd>Genuine parts for all types and brands of elevators and escalators.</dd>
          </dl>
        </div>
      </section>

      <!-- Why Choose Us -->
      <section class="about-why-choose block">
        <figure class="imgTitle" data-aos="fade-out">
          <img src="@/assets/img/product.jpg" alt="products">
          <figcaption>Why Choose Us</figcaption>
        </figure>
        <div class="bgTran">
          <ul>
            <li data-aos="fade-up">✅ Professional and certified engineers</li>
            <li data-aos="fade-up">✅ Commitment to safety and quality</li>
            <li data-aos="fade-up">✅ Affordable and transparent pricing</li>
            <li data-aos="fade-up">✅ Fast response and reliable support</li>
            <li data-aos="fade-up">✅ Customized solutions for every project</li>
          </ul>
        </div>
      </section>

		<!-- Certificates -->
		<section class="about-certificates block">
		<h2 class="mb-4" data-aos="fade-up">Our Certificates</h2>

		<div class="row row-cols-1 row-cols-sm-2 row-cols-md-4 g-4">
			<div
			class="col"
			v-for="(cert, index) in certificates"
			:key="index"
			data-aos="fade-up"
			>
			<div class="card h-100 shadow-sm">
				<iframe
				v-if="cert.file"
				:src="cert.file"
				class="card-img-top pdf-viewer"
				frameborder="0"
				style="height: 300px;"
				></iframe>
				<div class="card-body text-center">
				<h5 class="card-title">{{ cert.name }}</h5>
				<a :href="cert.file" target="_blank" class="btn btn-primary btn-sm mt-2">
					📄 View / Download
				</a>
				</div>
			</div>
			</div>
		</div>
		</section>


      <!-- Contact -->
      <section class="about-contact block">
        <h2>Contact Us</h2>
        <div class="col">
          <div class="left" data-aos="fade-right">
            <img src="@/assets/img/contact_us.png" alt="contact_us">
          </div>
          <div class="right" data-aos="fade-left">
            <p>
              If you are looking for <strong>new elevators, escalators, or maintenance services</strong>,
              Elemax-Tech Engineering Company Limited is your trusted partner in Myanmar.<br><br>
              📍 Address: {{ contacts?.address }}<br>
              📞 Phone: <a :href="'tel:' + normalizedPhones[0]" style="color:blue;">{{ normalizedPhones[0] }}</a><br>
              📧 Email: <a href="mailto:elemaxtechengineering.ete@gmail.com" style="color:blue;">elemaxtechengineering.ete@gmail.com</a><br>
              🌐 Website: <a href="https://www.elemaxtech.com" target="_blank" style="color:blue;">www.elemaxtech.com</a>
            </p>
          </div>
        </div>
      </section>

    </div>

    <ContentFooter />
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader.vue';
import ContentFooter from '@/components/ContentFooter.vue';
import axios from 'axios';

export default {
  name: 'AboutUsPage',
  components: { ContentHeader, ContentFooter },
  data() {
    return {
      contacts: null,
      apiBase: process.env.VUE_APP_API_BASE,
      apiToken: process.env.VUE_APP_API_TOKEN,
      loading: true,
      certificates: []
    };
  },
  computed: {
    normalizedPhones() {
      if (!this.contacts || !this.contacts.phone) return [];
      if (Array.isArray(this.contacts.phone)) return this.contacts.phone;
      try {
        const parsed = JSON.parse(this.contacts.phone);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [this.contacts.phone];
      }
    },
    normalizedSparePhones() {
      if (!this.contacts || !this.contacts.spareparts_phone) return [];
      if (Array.isArray(this.contacts.spareparts_phone)) return this.contacts.spareparts_phone;
      try {
        const parsed = JSON.parse(this.contacts.spareparts_phone);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [this.contacts.spareparts_phone];
      }
    }
  },
  async mounted() {
    // Auto-load PDFs
     const pdfModules = require.context(
      '@/assets/certificates',
      false,
      /\.pdf$/
    );
   this.certificates = pdfModules.keys().map(key => {
  const file = pdfModules(key).default; // just use it directly
  const name = key.replace('./', '');
  return { file, name };
});


    // Load contacts
    try {
      const response = await axios.get(`${this.apiBase}/api/contacts`, {
        headers: { Authorization: `Bearer ${this.apiToken}` },
      });
      this.contacts = response.data;
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }
};
</script>